export default "__VITE_ASSET__D_tyWZc1__"